import axios from 'axios'
import { OrganizationIntegrationListResponse } from 'src/models/organizationIntegration.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export type GetOrgIntegrationsResponse = {
  organizationConnections: OrganizationIntegrationListResponse[]
}

export type GetOrgIntegrationResponse = {
  organizationConnection: OrganizationIntegrationListResponse
}

export const getOrgIntegrationsList = async (
  orgId: string,
): Promise<GetOrgIntegrationsResponse> =>
  getResponseData(
    axios.get<GetOrgIntegrationsResponse>(
      `/organizations/${orgId}/connections`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const getOrgIntegrationDetail = async (
  orgId: string,
  connectionId: string,
): Promise<GetOrgIntegrationResponse> =>
  getResponseData(
    axios.get<GetOrgIntegrationResponse>(
      `/organizations/${orgId}/connections/${connectionId}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
